import { useState, useCallback } from 'react';

import { trackEvent } from '../../../../helpers/analytics';

export const usePasswordProtection = ({ sharedView, viewId, list, activeNetwork, updateView }) => {
  const [pwdVisible, setPwdVisible] = useState(false);
  const [pwdValue, setPwdValue] = useState('');
  const [passwordChanged, setPasswordChanged] = useState(false);
  const [showPassword, setShowPassword] = useState(sharedView?.passwordProtected || false);

  const onPasswordEnabled = useCallback(async () => {
    if (!viewId) return;

    try {
      await updateView({
        sharedListId: list.id,
        id: viewId,
        data: {
          passwordProtected: true,
          password: pwdValue,
        },
      });

      setPasswordChanged(true);
      trackEvent('contacts:list:enable_password', {
        collection_id: activeNetwork.id,
        list_id: list.id,
      });
    } catch (error) {
      // Error already handled by updateViewWithToast
    }
  }, [viewId, list.id, activeNetwork.id, pwdValue, updateView]);

  const onPasswordChange = useCallback(
    async (e) => {
      const { checked } = e.target;

      if (!checked && sharedView?.passwordProtected && viewId) {
        try {
          await updateView({
            sharedListId: list.id,
            id: viewId,
            data: {
              passwordProtected: false,
              password: '',
            },
          });

          setShowPassword(false);
          setPwdValue('');
        } catch (error) {
          // Error already handled by updateViewWithToast
        }
        return;
      }

      setShowPassword(!showPassword);
    },
    [showPassword, sharedView?.passwordProtected, viewId, list.id, updateView],
  );

  return {
    pwdVisible,
    setPwdVisible,
    pwdValue,
    setPwdValue,
    passwordChanged,
    setPasswordChanged,
    showPassword,
    onPasswordEnabled,
    onPasswordChange,
  };
};
